<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15S38FF/tc-custom/9780253005359.jpg?1713386064812" alt="This image is the cover for the book Muslim Families in Global Senegal"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Muslim Families in Global Senegal
      </h1>
      <p class="bookDescription body article font2">
        <b>“A first-rate ethnography of Muslim women in Dakar . . . [an] extremely fine-grained analysis of women’s exchange networks.” —Robert Launay, Northwestern University</b><br/><br/>Senegalese Murid migrants have circulated cargo and currency through official and unofficial networks in Africa and the world. <i>Muslim Families in Global Senegal</i> focuses on trade and the transmission of enduring social value though cloth, videos of life-cycle rituals, and religious offerings. Highlighting women’s participation in these networks and the financial strategies they rely on, Beth Buggenhagen reveals the deep connections between economic profits and ritual and social authority. Buggenhagen discovers that these strategies are not responses to a dispersed community in crisis, but rather produce new roles, wealth, and worth for Senegalese women in all parts of the globe.<br/><br/><b>“A lively, insightful, and important study of exchange practices between Senegal and a circuit of global trade. The innovative focus is on the meanings, not the social and economic functions, of exchange.” —Karen Tranberg Hansen, Northwestern University</b><br/><br/><b>“While the author’s focus is on the transformation in the role of women both within the family network and in the marketplace, the book allows readers to better understand the impact of globalism on the citizens of Senegal . . . Recommended.” —<i>Choice</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beth Buggenhagen
      </h2>
      
      <p class="authorDescription body article"><P>Beth Buggenhagen is Assistant Professor of Anthropology at Indiana University Bloomington. She is editor (with Anne-Maria Makhulu and Stephen Jackson) of Hard Work, Hard Times: Global Volatility and African Subjectivities.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e117976